/**
 * Constants for NCR Edit module
 */

import { StepConfig } from './types';

export const WORKFLOW_STEPS: StepConfig[] = [
  { num: 1, label: 'Created', sublabel: 'NCR raised', role: 'Customer' },
  { num: 2, label: 'CA Submitted', sublabel: 'Root cause analysis', role: 'Supplier' },
  { num: 3, label: 'CAR Submitted', sublabel: 'Corrective action', role: 'Supplier' },
  { num: 4, label: 'Closed', sublabel: 'Complete', role: 'Customer' },
];

// CR-7069: Only why_1 is mandatory. WHY 2-5 are optional — the supplier may
// stop at any depth when the root cause is found (e.g., stop at WHY 3).
export const RCA_REQUIRED_FIELDS = [
  'why_1',
  'selected_root_cause',
  'immediate_corrective_action',
];

// CR-5999: User-friendly labels for the RCA required fields so validation
// messaging surfaces what the user actually sees on screen ("Why 1?",
// "Immediate Containment Action") instead of raw API field names
// ("why_1", "immediate_corrective_action").
export const RCA_FIELD_LABELS: Record<string, string> = {
  immediate_corrective_action: 'Immediate Containment Action',
  why_1: 'Why 1?',
  why_2: 'Why 2?',
  why_3: 'Why 3?',
  why_4: 'Why 4?',
  why_5: 'Why 5?',
  selected_root_cause: 'Selected Root Cause',
};

export const CAR_REQUIRED_FIELDS = ['corrective_action', 'preventive_action', 'impact_assessment'];

// CR-6000: User-friendly labels for the required CAR fields so the Submit CAR
// validation surfaces what the user sees on screen ("Corrective Action") rather
// than raw API field names ("corrective_action"). Mirrors RCA_FIELD_LABELS.
export const CAR_FIELD_LABELS: Record<string, string> = {
  corrective_action: 'Corrective Action',
  preventive_action: 'Preventive Action',
  impact_assessment: 'Impact Assessment',
};
